import { dataMigrationService } from '../services/dataMigrationService';
import { MigrationOptions } from '../types';

/**
 * 마이그레이션 실행 유틸리티
 * 개발자 도구나 별도 스크립트에서 실행할 수 있도록 제공
 */

/**
 * 마이그레이션 실행 함수 (브라우저 콘솔에서 사용)
 */
export async function runMigration(
  userId: string, 
  classId: string, 
  options: MigrationOptions = {}
): Promise<void> {
  console.log('🚀 마이그레이션 시작...');
  console.log('사용자 ID:', userId);
  console.log('클래스 ID:', classId);
  console.log('옵션:', options);
  
  // 진행 상태 모니터링
  const progressInterval = setInterval(() => {
    const progress = dataMigrationService.getProgress();
    console.log(`진행률: ${progress.completed}/${progress.total} (${Math.round(progress.completed/progress.total*100)}%)`);
    console.log('현재 처리 중:', progress.current);
    
    if (progress.errors.length > 0) {
      console.log('오류:', progress.errors.slice(-5)); // 최근 5개 오류만 표시
    }
  }, 2000);
  
  try {
    const result = await dataMigrationService.migrateAllData(userId, classId, options);
    
    clearInterval(progressInterval);
    
    console.log('✅ 마이그레이션 완료!');
    console.log('결과:', result);
    
    if (result.errorCount > 0) {
      console.warn(`⚠️ ${result.errorCount}개의 오류가 발생했습니다.`);
      console.log('오류 목록:', result.errors);
    }
    
  } catch (error) {
    clearInterval(progressInterval);
    console.error('❌ 마이그레이션 실패:', error);
    throw error;
  }
}

/**
 * 마이그레이션 검증 함수 (dry run)
 */
export async function validateMigration(
  userId: string, 
  classId: string
): Promise<void> {
  console.log('🔍 마이그레이션 검증 시작...');
  
  const options: MigrationOptions = {
    dryRun: true,
    batchSize: 50
  };
  
  await runMigration(userId, classId, options);
  
  console.log('✅ 검증 완료 - 실제 마이그레이션을 실행하려면 dryRun: false로 설정하세요');
}

/**
 * 마이그레이션 롤백 함수 (백업에서 복원)
 */
export async function rollbackMigration(
  userId: string, 
  classId: string,
  backupData: any
): Promise<void> {
  console.log('🔄 마이그레이션 롤백 시작...');
  console.warn('⚠️ 이 기능은 아직 구현되지 않았습니다.');
  console.warn('수동으로 백업 데이터를 복원해주세요.');
}

/**
 * 마이그레이션 상태 확인 함수
 */
export function getMigrationStatus(): void {
  const progress = dataMigrationService.getProgress();
  const result = dataMigrationService.getResult();
  
  console.log('📊 마이그레이션 상태:');
  console.log('진행률:', progress);
  console.log('결과:', result);
}

// 브라우저 전역 객체에 등록 (개발자 도구에서 사용)
if (typeof window !== 'undefined') {
  (window as any).runMigration = runMigration;
  (window as any).validateMigration = validateMigration;
  (window as any).rollbackMigration = rollbackMigration;
  (window as any).getMigrationStatus = getMigrationStatus;
  
  console.log('🔧 마이그레이션 유틸리티가 브라우저 전역에 등록되었습니다:');
  console.log('- runMigration(userId, classId, options)');
  console.log('- validateMigration(userId, classId)');
  console.log('- getMigrationStatus()');
}
